import type { CSSProperties } from 'react';
import { useTheme } from '@mui/material/styles';
import { BadgeAlert, CheckCircle2, Info, LoaderCircle, TriangleAlert, X } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const iconClassName = 'h-4 w-4';

export function Toaster(props: ToasterProps) {
  const theme = useTheme();

  return (
    <Sonner
      closeButton
      expand={false}
      position="top-right"
      theme={theme.palette.mode as ToasterProps['theme']}
      visibleToasts={3}
      offset={{ top: 24, right: 24, bottom: 24, left: 24 }}
      mobileOffset={{ top: 16, right: 16, bottom: 16, left: 16 }}
      richColors
      icons={{
        success: <CheckCircle2 className={iconClassName} />,
        error: <BadgeAlert className={iconClassName} />,
        warning: <TriangleAlert className={iconClassName} />,
        info: <Info className={iconClassName} />,
        loading: <LoaderCircle className={`${iconClassName} animate-spin`} />,
        close: <X className={iconClassName} />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group pointer-events-auto rounded-2xl border px-4 py-3 shadow-lg backdrop-blur-sm',
          title: 'text-sm font-semibold',
          description: 'text-sm opacity-80',
          content: 'gap-1.5',
          icon: 'mt-0.5',
          closeButton:
            'border-0 bg-transparent text-current opacity-70 transition-opacity hover:opacity-100',
          actionButton:
            'rounded-md bg-white/90 px-3 py-2 text-xs font-semibold text-foreground transition-colors hover:bg-white',
          cancelButton:
            'rounded-md border border-white/30 bg-transparent px-3 py-2 text-xs font-semibold text-current transition-colors hover:bg-white/10',
        },
      }}
      style={
        {
          '--normal-bg': theme.palette.background.paper,
          '--normal-text': theme.palette.text.primary,
          '--normal-border': theme.palette.divider,
        } as CSSProperties
      }
      {...props}
    />
  );
}
